module.exports = __webpack_public_path__ + "static/img/bg.9b40241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/commonRankBoard/assets/bg.jpg
// module id = bx7S
// module chunks = 3